
import ReactHTMLTableToExcel from "react-html-table-to-excel"



export const ExportStudentData = (props) => {
    const { ExcelData, name } = props

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                // className="btn export_btn mx-2 float-end"
                className=" btn btn-success submit-btn float-end download-table-xls-button me-3 btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'gray' }}
            />

            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%', border: "1px solid gray" }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name ? name :''}</h4>

                <thead>

                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid gray', borderTop: "1px solid gray" }}>
                        <th>Sr. No.</th>
                        <th>Student Name</th>
                        <th>Age (Year)</th>
                        <th>Contact Number</th>
                        <th>Email ID</th>
                        <th>Employement</th>
                        <th>Name Of Organization</th>
                        <th>Reason</th>
                        <th>Exam Fess (Rs.)</th>
                        <th>Receipt</th>
                    </tr>

                </thead>

                <tbody>
                    
                    {ExcelData && ExcelData?.table?.length > 0 ? (
                        ExcelData?.table?.map((i, index) => (
                            <tr key={index}>

                                <td align="center">{i?.rowNum}</td>
                                <td align="left" className="text-capitalize">{i?.fullName}</td>
                                <td align="center">{i?.age}</td>
                                <td align="center">{i?.contactNumber}</td>
                                <td align="center">{i?.email}</td>
                                <td align="center" className="text-capitalize">{i?.category_M_Indicator}</td>
                                <td align="left" className="text-capitalize">{i?.name_Of_Organization}</td>
                                <td align="left" className="text-capitalize">{i?.examinationPurpose}</td>
                                <td align="right">&#8377; {i?.paidExamFee ? i?.paidExamFee.toFixed(2) : '0'}</td>
                                <td align="center">
                                    {
                                        (i?.uploadReceipt && i?.uploadReceipt != '') ?
                                            <a href={i?.uploadReceipt} style={{ cursor: 'pointer' }}
                                                onClick={() => window.open(i?.uploadReceipt)}>
                                                View Receipt
                                            </a>
                                            : '-'
                                    }
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="33" style={{ textAlign: 'center' }}>No data found</td>
                        </tr>
                    )}
                </tbody>

            </table>
        </div >
    )
}